import {BaseModule} from "./base/base";

export class QuestionSelect extends BaseModule {
    constructor(selector = '.question-select') {
        super();
        const select = document.querySelector(selector) as HTMLSelectElement;
        if (select) {
            select.addEventListener('change', () => {
                const selectedValue = select.value;
                if (selectedValue) {
                    window.location.href = selectedValue;
                }
            });
        }
    }

}
